import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';

export const APPS_PHONE_QUERY = `(max-width: ${SIDEBAR_MOBILE_BREAKPOINT}px)`;
export const APPS_PHONE_MEDIA = `@media ${APPS_PHONE_QUERY}`;

export const BUILDER_COMPACT_QUERY = '(max-width: 1279px)';
